module.exports = __webpack_public_path__ + "assets/img/title.a275acc9.png";